import { bool, element, func, number, oneOfType, string } from 'prop-types';
import React from 'react';

export default function FeatureListItem({ isMobile, heading, text, link, Icon = <></>, featureWidth }) {
    return (<div
        className={'feature-list-item ms-lg-4 me-lg-4 ms-3 me-3'}
        style={{
            ...(isMobile === true) && ({ width: `${featureWidth}%` }),
        }}
    >
        <Icon
            size={!isMobile ? '50px' : '25px'} />
        <div
            className={'feature-list-item--inner ms-2'}>
            <span
                className={'feature-list-item--heading'}>{heading}</span>
            {(text && !link) && (<p
                className={'feature-list-item--text'}>{text}</p>)}
            {(text && link) && (<a
                className={'feature-list-item--link'}
                href={link}
                target={'_blank'}
                rel={'noreferrer'}>{text}</a>)}
        </div>
    </div>);
}

FeatureListItem.propTypes = {
    isMobile: bool,
    heading: string,
    text: string,
    link: string,
    Icon: oneOfType([element, func]),
    featureWidth: oneOfType([number, string]),
};